export default {
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/date/DateConstants.js